import { didTeamWin } from '@/common/utils';

import type { BracketCardProps } from './BracketCard.types';
import { BracketCardRow } from './BracketCardRow';

export default function BracketCard(props: BracketCardProps) {
  const {
    className,
    formattedDate,
    formattedTime,
    homeTeamName,
    awayTeamName,
    homeImageSrc,
    awayImageSrc,
    previousMeetingScore,
    finalScore,
    penaltyScore,
    isTbdHidden,
  } = props;

  const hasDate = !!formattedDate?.trim();
  const hasTime = !!formattedTime?.trim();
  const hasDateOrTime = hasDate || hasTime;

  const didHomeTeamWin = didTeamWin({
    teamScore: finalScore?.home ?? 0,
    opponentScore: finalScore?.away ?? 0,
    teamPenaltyScore: penaltyScore?.home ?? 0,
    opponentPenaltyScore: penaltyScore?.away ?? 0,
  });
  const didAwayTeamWin = didTeamWin({
    teamScore: finalScore?.away ?? 0,
    opponentScore: finalScore?.home ?? 0,
    teamPenaltyScore: penaltyScore?.away ?? 0,
    opponentPenaltyScore: penaltyScore?.home ?? 0,
  });

  return (
    <div
      className={`p-2 flex flex-col gap-2 rounded-[16px] border border-pmw-separator-light dark:border-pmw-separator-dark bg-pmw-sb-2-secondary-light dark:bg-pmw-sb-2-secondary-dark ${className}`}
    >
      {hasDateOrTime && (
        <div className="flex gap-1 font-robotoMedium text-[12px] leading-[16px] text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark">
          {hasDate && <span>{formattedDate}</span>}
          {hasDate && hasTime && <div className="w-px bg-pmw-separator-gradient opacity-60" />}
          {hasTime && <span>{formattedTime}</span>}
        </div>
      )}
      <div className="flex-1 flex flex-col gap-1">
        <BracketCardRow
          teamName={homeTeamName}
          imageSrc={homeImageSrc}
          lastMeetingGoals={previousMeetingScore?.home}
          finalGoals={finalScore?.home}
          penaltyGoals={penaltyScore?.home}
          isLoser={didAwayTeamWin}
          isTbdHidden={isTbdHidden}
        />
        <BracketCardRow
          teamName={awayTeamName}
          imageSrc={awayImageSrc}
          lastMeetingGoals={previousMeetingScore?.away}
          finalGoals={finalScore?.away}
          penaltyGoals={penaltyScore?.away}
          isLoser={didHomeTeamWin}
          isTbdHidden={isTbdHidden}
        />
      </div>
    </div>
  );
}
